























































































































/* tslint:disable:no-console */
import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { TableConfig, IDRec, VForm } from '@/interfaces';
import CommonMixin from '../mixins/CommonMixin';

@Component({
  metaInfo() {
    return {
      title: (this as any).detailTitle
    };
  }
})
export default class DetailLayout extends Mixins(CommonMixin) {
  // Props
  @Prop(Object) public tableCfg!: TableConfig;
  @Prop(String) public id!: string;
  @Prop({ type: Boolean, default: false }) public readonly customSave!: boolean;
  @Prop({ type: Boolean, default: false }) public toOverviewAfterSave!: boolean;

  // Variables
  public priv = this.getTableCfg(this.tableCfg, 'priv');
  public apiUrl = this.formatUrl(this.getTableCfg(this.tableCfg, 'apiUrl'));
  public url = this.formatUrl(this.getTableCfg(this.tableCfg, 'url'));
  public overviewUrl = this.getTableCfg(this.tableCfg, 'overviewUrl')
    ? this.formatUrl(this.getTableCfg(this.tableCfg, 'overviewUrl'))
    : this.url;
  public addRecord =
    this.getTableCfg(this.tableCfg, 'addRecord') !== undefined
      ? this.getTableCfg(this.tableCfg, 'addRecord')
      : true;
  public detailTitle = this.getTableCfg(this.tableCfg, 'detailTitle');
  public deleteTitle = this.getTableCfg(this.tableCfg, 'deleteTitle');
  public newRecord = this.getTableCfg(this.tableCfg, 'newRecord');
  public forEdit = this.getTableCfg(this.tableCfg, 'forEdit')
    ? this.getTableCfg(this.tableCfg, 'forEdit')
    : false;
  public rec: IDRec = { id: 0 };
  public loading = false;
  public formValid = false;
  public deleteDialogValue = false;

  // Computed
  public get readPrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'Read') : true;
  }

  public get writePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'Write') : true;
  }

  public get managePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'Manage') : true;
  }

  public get editPrivilege() {
    return this.writePrivilege;
  }

  public get isReadOnly() {
    return !this.editPrivilege || (!this.isEdit && !this.isNew);
  }

  public get isEdit() {
    return this.editPrivilege && this.$route.query.mode === 'edit';
  }

  public get isNew() {
    return this.editPrivilege && this.$route.params.id === 'new';
  }

  public get isSaveDisabled() {
    return this.loading;
  }

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

  public customEditable(item) {
    if (this.tableCfg.customEditable) {
      return this.getTableCfg(this.tableCfg, 'customEditable', item);
    } else {
      return true;
    }
  }

  public customDeletable(item) {
    if (this.tableCfg.customDeletable) {
      return this.getTableCfg(this.tableCfg, 'customDeletable', item);
    } else {
      return true;
    }
  }

  public goToOverview() {
    this.$router.push(this.overviewUrl);
  }

  public async onEdit() {
    if (this.forEdit) {
      this.getForEditRecord(this.rec.id);
    }
    this.$router.push(this.url + '/' + String(this.rec.id) + '?mode=edit');
  }

  public onUndoEdit() {
    this.$router.push(this.url + '/' + String(this.rec.id));
    this.getRecord();
  }

  public async getForEditRecord(id) {
    this.loading = true;
    const response = await this.api.getRecord(this.$store, this.apiUrl + id, {
      for_edit: 'yes'
    });
    if (response) {
      this.rec = response.data;
      this.$emit('loaded', this.rec);
      this.theForm.resetValidation();
      this.loading = false;
    }
  }

  public async getRecord() {
    if (this.isNew) {
      if (this.newRecord) {
        // JSON parse and stringify remove the observer so tableCfg.newRecord will not be changed
        this.rec = JSON.parse(
          JSON.stringify({ ...this.rec, ...this.newRecord })
        );
        for (const query in this.$route.query) {
          if (query) {
            if (query.includes('id')) {
              this.rec[query] = Number(this.$route.query[query]);
            } else {
              this.rec[query] = this.$route.query[query];
            }
          }
        }
      }
    } else {
      this.loading = true;
      let id = '';
      if (this.id) {
        // Use ID that is given as a prop
        id = this.id;
      } else {
        // Get ID from URL
        id = this.$route.params.id;
      }
      if (this.isEdit && this.forEdit) {
        this.getForEditRecord(id);
      } else {
        const response = await this.api.getRecord(
          this.$store,
          this.apiUrl + id
        );
        if (response) {
          this.rec = response.data;
          this.$emit('loaded', this.rec);
          this.theForm.resetValidation();
          this.loading = false;
        }
        // if (this.newRecord) {
        //   for (const key of Object.keys(this.newRecord)) {
        //     if (this.newRecord[key] && !this.rec[key]) {
        //       console.log('getRecord missing key', key);
        //       this.rec[key] = JSON.parse(
        //         JSON.stringify({ ...this.newRecord[key] })
        //       );
        //     }
        //   }
        // }
      }
    }
  }

  public async saveRecord() {
    const rec: IDRec = this.rec;
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      this.loading = true;
      if (this.customSave) {
        this.$emit('save', rec, this.apiUrl);
      } else {
        this.commitRecord(rec);
      }
    }
  }

  public async commitRecord(rec) {
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      if (this.isNew) {
        const response = await this.api.createRecord(
          this.$store,
          this.apiUrl,
          rec
        );
        if (response) {
          this.loading = false;
          this.rec = response.data;
          if (this.toOverviewAfterSave) {
            this.goToOverview();
          } else {
            this.$router.push(this.url + '/' + this.rec.id);
          }
        } else {
          this.loading = false;
        }
      } else {
        const response = await this.api.updateRecord(
          this.$store,
          this.apiUrl + rec.id,
          rec
        );
        if (response) {
          this.rec = response.data;
          this.$emit('loaded', this.rec);
        }
        this.loading = false;
        if (this.toOverviewAfterSave) {
          this.goToOverview();
        } else {
          // Avoid duplicate route error
          const newRoute = this.url + '/' + rec.id;
          if (
            this.$route.path !== newRoute ||
            !this.isEmpty(this.$route.query)
          ) {
            this.$router.push(newRoute);
          }
        }
      }
    }
  }

  public async deleteRecord() {
    await this.api.deleteRecord(this.$store, this.apiUrl + this.rec.id);
    this.goToOverview();
  }

  // Helper Functions
  public isEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  public formatUrl(url) {
    const re = /\{\w+\}/g;
    return url.replace(re, this.getId);
  }

  public getId(match) {
    const id = match.substring(1, match.length - 1);
    return this.$route.params[id];
  }

  @Watch('$route.params.id') public routeChanged(oldValue, newValue) {
    this.getRecord();
  }

  // Lifecycle Functions
  public created() {
    if (!this.readPrivilege) {
      this.$router.push('/noaccess');
    }
  }

  public mounted() {
    if (this.isNew && !this.addRecord) {
      // Add new record is not allowed
      this.goToOverview();
    }
    this.getRecord();
  }
}
